import { useMutation } from '@src/query';


/**
 * Shared engine behind the four part-channel toggle wrappers (audit 0e0750a0):
 * `usePartChannelToggleMutation`, `usePartChannelOffMutation`,
 * `useListingChannelToggleMutation`, `usePartChannelMutation`. All POST the same
 * `/inventory/parts/<seller>/<part>/channels/` endpoint; they differed only in
 * the request body they build and the cache key(s) they invalidate — the request
 * wrapper itself was duplicated four times.
 *
 * `buildPayload(vars)` returns the request body; `invalidate(vars)` (optional)
 * runs the caller's invalidation after the POST resolves. Invalidation is
 * fire-and-forget and NOT awaited, matching each original hook's behavior. `vars`
 * carries the injected `{ apiClient, queryClient }` plus the caller's variables,
 * so `invalidate` reads `queryClient`/`sellerId`/`keyPrefix` straight off it.
 */
function usePartChannelPostMutation({ buildPayload, invalidate }, params) {
  return useMutation({
    mutateFn: (vars) => vars.apiClient
      .request({
        url: `/inventory/parts/${vars.sellerId}/${vars.partId}/channels/`,
        method: 'POST',
        payload: buildPayload(vars),
      })
      .then((data) => {
        invalidate?.(vars);
        return data;
      }),
    ...params,
  });
}


export default usePartChannelPostMutation;
